import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  // 加入代码
  scrollBehavior(to, from, savedPosition) {
    // 解决路由跳转后 会滚动到底部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  // noShowTop：0：有头和尾，1:只有尾，2:都没有
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: () => import('@/views/index')
    // },

    {
      path: '/query',
      name: 'query',
      component: () => import('@/views/foot/seatch')
    },
     {
      path: '/foot',
      name: 'foot',
      component: () => import('@/views/foot')
    },
    
    {
      path: '/invalid',
      name: 'invalid',
      component: () => import('@/views/foot/invalid')
    },
    {
      path: '*', // 此处需特别注意置于最底部
      redirect: '/404'
    },

    {
      path: '/404',
      name: '404',
      component: () => import('@/views/foot/404')
    }
  ]
})

router.beforeEach((to, from, next) => {
  const title = to.meta.title
  if (title) {
    document.title = title
  }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js